export const types = {
  NAVIGATE_BACK: 'NAVIGATE_BACK',
  NAVIGATE_FORWARD: 'NAVIGATE_NEXT',
};

export const navigateBack = (state, formName) => ({
  type: types.NAVIGATE_BACK,
  payload: { state },
  formName,
});

export const navigateForward = (state, formName) => ({
  type: types.NAVIGATE_FORWARD,
  payload: { state },
  formName,
});
